export default __webpack_public_path__ + "static/media/no-image-available.6dea9489.jpg";